'use client';

import { Grid } from '@terra/ui-styled-system';
import { useFindingsSeverityCounts } from '../../hooks/dashboard/useFindingsSeverityCounts';
import { useTargetFindingsSeverityCounts } from '../../hooks/dashboard/useTargetFindingsSeverityCounts';
import { useTargetType } from '../../store/projectStore';
import { TARGET_TYPE } from '../../utils/target-scope.utils';
import { ExecutionsOutcomePostureCard } from './ExecutionsOutcomePostureCard';
import { FindingsSeverityPostureCard } from './FindingsSeverityPostureCard';
import { SignalsStagePostureCard } from './SignalsStagePostureCard';

type PostureStripProps = {
  applicationId: string;
};

export function PostureStrip({ applicationId }: PostureStripProps) {
  const targetType = useTargetType();
  const isWebApplication = targetType === TARGET_TYPE.WEB_APPLICATION;
  const applicationSeverity = useFindingsSeverityCounts(
    isWebApplication ? applicationId : '',
  );
  const targetSeverity = useTargetFindingsSeverityCounts({
    targetId: isWebApplication ? null : applicationId,
    targetType,
  });
  const severity = isWebApplication ? applicationSeverity : targetSeverity;

  return (
    <Grid w="full" columns={{ base: 1, lg: 3 }} gap={4} alignItems="stretch">
      <FindingsSeverityPostureCard
        applicationId={applicationId}
        counts={severity.data}
        isLoading={severity.isLoading}
      />
      <SignalsStagePostureCard applicationId={applicationId} />
      <ExecutionsOutcomePostureCard applicationId={applicationId} />
    </Grid>
  );
}
